import { render, staticRenderFns } from "./CookieCategory.vue?vue&type=template&id=3903fe3e&scoped=true&"
import script from "./CookieCategory.vue?vue&type=script&lang=ts&"
export * from "./CookieCategory.vue?vue&type=script&lang=ts&"
import style0 from "./CookieCategory.vue?vue&type=style&index=0&id=3903fe3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3903fe3e",
  null
  
)

export default component.exports